import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ajaxUtils } from '@nestech/utils';
import { map, Observable } from 'rxjs';
import { isApiUrl } from './api-url';
import { isConverableJsonResponse } from './interceptor-utils';

const convertBody = (body: unknown): unknown => ajaxUtils.convertJSONDates(body);

const isInterceptable = (request: HttpRequest<unknown>) => isApiUrl(request.url) && request.responseType === 'json';

@Injectable()
export class ConvertDateInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!isInterceptable(request)) {
      return next.handle(request);
    }
    return next
      .handle(request)
      .pipe(
        map((event: HttpEvent<any>) =>
          isConverableJsonResponse(event) ? event.clone({ body: convertBody(event.body) }) : event,
        ),
      );
  }
}
